// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCMp2Z9vF5t1dwSk5SvB9wDZmeSIEXIUP8",
  authDomain: "courriers-4a7b9.firebaseapp.com",
  projectId: "courriers-4a7b9",
  storageBucket: "courriers-4a7b9.appspot.com",
  messagingSenderId: "889262319783",
  appId: "1:889262319783:web:474c86060edb01189e9382",
  measurementId: "G-SSQCDTNSMN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
export default app;